import { Divider } from "@mui/material";
import dayjs from "dayjs";
import { useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";

import { CollapsibleCard } from "@/features/trips/components/CollapsibleCard";
import {
  DetailsList,
  DetailsListItem,
} from "@/features/trips/components/DetailsList";
import { RoomList } from "@/features/trips/components/RoomList";
import type { BookingData } from "@/features/trips/types/types";
import type { TripDetails } from "@/features/trips/types/types";

type Props = {
  trip: TripDetails;
};

export function TripDetailsCard({ trip }: Props) {
  const t = useTranslations();
  const tripDate = useWatch<BookingData, "tripDate">({ name: "tripDate" });
  const travellers = useWatch<BookingData, "travellers">({
    name: "travellers",
  });

  return (
    <CollapsibleCard title={t("trips.tripDetails.title")} collapsible={false}>
      <DetailsList>
        <DetailsListItem
          title={t("trips.travelStartDate")}
          value={dayjs(tripDate).format("D MMMM, YYYY")}
        />

        <DetailsListItem
          title={t("trips.travelEndDate")}
          value={dayjs(tripDate)
            .add(trip.durationInDays, "day")
            .format("D MMMM, YYYY")}
        />

        <DetailsListItem
          title={t("trips.travelLength")}
          value={t("trips.duration", {
            nights: trip.durationInDays - 1,
            days: trip.durationInDays,
          })}
        />

        <DetailsListItem
          title={t("trips.flightOperator")}
          value={trip.airline}
        />
      </DetailsList>

      <Divider
        sx={{
          borderColor: "var(--color-stroke-neutral-soft)",
          my: "calc(var(--spacing)*3)",
        }}
      />

      <div className="mb-1 text-sm text-text-disabled-primary">
        {t("trips.tripDetails.rooms")}
      </div>
      <RoomList rooms={travellers} />
    </CollapsibleCard>
  );
}
